import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { LOADER_SIZES_MAP as p } from "./constants21.mjs";
import { GlobalWrapper as m, Wrapper as f, LoaderWrapper as h, StyledLoaderBackground as L, StyledLoader as u } from "./styles21.mjs";
const x = ({
  withWrapper: i = !1,
  size: o = "lg",
  isGlobal: n = !1,
  className: d,
  height: l,
  fullHeight: s
}) => {
  const r = p[o], t = () => /* @__PURE__ */ c(h, { className: d, children: [
    /* @__PURE__ */ e(
      L,
      {
        variant: "determinate",
        value: 100,
        size: r
      }
    ),
    /* @__PURE__ */ e(
      u,
      {
        variant: "indeterminate",
        disableShrink: !0,
        size: r
      }
    )
  ] }), a = () => i ? /* @__PURE__ */ e(f, { $height: l, $fullHeight: s, children: t() }) : t();
  return n ? /* @__PURE__ */ e(m, { children: a() }) : a();
};
export {
  x as Loader
};
//# sourceMappingURL=index40.mjs.map
